<template>
    <div>
        <vx-card title="" no-shadow card-border id="div-detalle-persona-with-loading" class="mt-base">

            <div class="flex items-end">
                <feather-icon :icon="iconTitle" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">{{ title }}</span>
            </div>

            <vs-divider/>

            <div class="mt-4 mb-8">
                <vs-alert active="true" color="warning" icon-pack="feather" icon="icon-info">
                    <span> Para crear o actualizar, el personal debe contar con <strong>Propuesta Laboral Activo </strong>dentro de la Institución, caso contrario apersonarse al area de Recursos Humanos.</span>
                </vs-alert>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="text-sm opacity-75">Número de Documento de Identidad</label>
                    <div class="vx-row">
                        <div class="w-full mb-2 vx-col md:w-1/2">
                            <vs-input class="w-full" :readonly="enabledDocumento" v-model="inputDocumento" v-validate="'required|numeric'" name="documento" placeholder="Ingrese DNI"/>
                            <span class="text-sm text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</span>
                        </div>

                        <div class="w-full vx-col md:w-1/2">
                            <vs-button @click="buscarPersonal" icon-pack="feather" color="danger" type="border" icon="icon-search">{{ enabledDocumento ? 'Actualizar' : 'Buscar'}}</vs-button>
                        </div>

                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">                   
                    <div class="mb-2">
                        <label class="text-sm opacity-75">Nombres</label>
                        <vs-input class="w-full" v-model="inputNombres" v-validate="'required'" name="nombres" placeholder="Ingrese nombres"/>
                        <span class="text-sm text-danger" v-show="errors.has('nombres')">{{ errors.first('nombres') }}</span>
                    </div>

                    <div class="mb-2">
                        <label class="text-sm opacity-75">Apellidos</label>
                        <vs-input class="w-full" v-model="inputApellidos" v-validate="'required'" name="apellidos" placeholder="Ingrese apellidos"/>
                        <span class="text-sm text-danger" v-show="errors.has('apellidos')">{{ errors.first('apellidos') }}</span>
                    </div>

                    <div class="mb-2">
                        <label class="text-sm opacity-75">Email</label>
                        <vs-input class="w-full" v-model="inputEmail" v-validate="'required|email'" type="email" name="email" placeholder="Ingrese correo electrónico"/>
                        <span class="text-sm text-danger" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                    </div>

                </div>
                
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <div class="mb-2">
                        <label class="text-sm opacity-75">Telefono/Movil</label>
                        <vs-input class="w-full" v-model="inputTelefono" v-validate="'numeric'" name="telefono" placeholder="Ingrese telf. movil o fijo"/>
                        <span class="text-sm text-danger" v-show="errors.has('telefono')">{{ errors.first('telefono') }}</span>
                    </div>

                    <div class="mb-2">
                        <label class="text-sm opacity-75">Dirección</label>
                        <vs-input class="w-full" v-model="inputDireccion" v-validate="''" name="direccion" placeholder="Ingrese dirección"/>
                        <span class="text-sm text-danger" v-show="errors.has('direccion')">{{ errors.first('direccion') }}</span>
                    </div>

                    <div class="mb-2">
                        <label class="text-sm opacity-75">Profesión</label>
                        <vs-input class="w-full" v-model="inputProfesion" v-validate="''" name="profesion" placeholder="Ingrese profesión"/>
                        <span class="text-sm text-danger" v-show="errors.has('profesion')">{{ errors.first('profesion') }}</span>
                    </div>

                </div>
            </div>

            <div class="vx-row">
                <div class="w-full vx-col md:w-1/2">
                    <div class="mb-2">
                        <label class="text-sm opacity-75">Oficina</label>
                        <v-select :options="itemsOficina" v-model="selectedOficina" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="cargo">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('oficina')">{{ errors.first('oficina') }}</span>
                    </div>
                </div>

                <div class="w-full vx-col md:w-1/2">
                    <div class="mb-2">
                        <label class="text-sm opacity-75">Unidad Ejecutora</label>
                        <v-select :options="itemsEjecutora" v-model="selectedEjecutora" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="unidadEjecutora">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('unidadEjecutora')">{{ errors.first('unidadEjecutora') }}</span>
                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">                   
                    <div class="mb-2">
                        <label class="text-sm opacity-75">Categoria</label>
                        <vs-input class="w-full" v-model="inputCategoria" v-validate="''" name="categoria" placeholder="Ingrese categoria"/>
                        <span class="text-sm text-danger" v-show="errors.has('categoria')">{{ errors.first('categoria') }}</span>
                    </div>
                </div>
            </div>

        </vx-card>

        <vx-card title="" class="mt-2" no-shadow card-border>
            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">

                    <div class="w-full mb-2 vx-col">
                        <label class="text-sm opacity-75">Cargo</label>
                        <v-select :options="itemsCargo" v-model="selectedCargo" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="cargo">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('cargo')">{{ errors.first('cargo') }}</span>
                    </div>

                    <div class="mb-2">
                        <label class="text-sm opacity-75">Dispositivo a usar</label>
                        <v-select :options="itemsDevice" v-model="selectedDevice" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="estado">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                    </div>

                </div>

                <div class="w-full mb-2 vx-col md:w-1/2">
                    <div class="w-full mb-2 vx-col">
                        <label class="text-sm opacity-75">Perfil</label>
                        <v-select :options="itemsPeril" v-model="selectedPerfil" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="perfil">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('perfil')">{{ errors.first('perfil') }}</span>
                    </div>

                    <div class="mb-2">
                        <label class="text-sm opacity-75">Estado</label>
                        <v-select :options="itemsEstado" v-model="selectedEstado" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="estado">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                    </div>

                </div>

            </div>

            <div class="w-full mt-2 vx-col">
                <div class="flex flex-wrap items-center justify-start">
                    <vs-button @click="guardar" icon-pack="feather" color="primary" icon="icon-save" class="mt-2 ml-auto" :disabled="!validateForm">Guardar</vs-button>
                    <vs-button @click="regresar" icon-pack="feather" color="warning" type="border" icon="icon-rotate-ccw"  class="mt-2 ml-4">Regresar</vs-button>
                    <vs-button @click="clearForm" icon-pack="feather" color="danger" type="border" icon="icon-trash"  class="mt-2 ml-4">Limpiar</vs-button>
                </div>
            </div>
            
        </vx-card>

    </div>
</template>
<script>
import vSelect from 'vue-select';

export default {
    components: {
        'v-select': vSelect
    },
    
    data(){
        return {
            title               : 'Nuevo Personal',
            iconTitle           : 'UserPlusIcon',

            enabledDocumento    : false,
            personalId          : null,
            inputDocumento      : null,
            inputNombres        : null,
            inputApellidos      : null,
            inputEmail          : null,
            inputTelefono       : null,
            inputDireccion      : null,
            inputAreaAbreviatura: null,
            inputArea           : null,
            inputCategoria      : null,
            inputProfesion      : null,

            selectedOficina     : null,
            selectedCargo       : null,
            selectedPerfil      : null,
            selectedDevice      : null,
            selectedEstado      : null,
            selectedEjecutora   : null,

            itemsCargo          : [],
            itemsPeril          : [],
            itemsOficina        : [],
            itemsEjecutora      : [],
            itemsDevice         : [{ value: 1, label: 'Web' }, { value: 2, label: 'Android' }, { value: 3, label: 'IPhone' }, { value: 4, label: 'Otros dispositivos' }],
            itemsEstado         : [{ value: 1, label: 'ACTIVO' }, { value: 2, label: 'BLOQUEADO' }],

        }
    },
    created(){
        this.parametro = this.$route.params.id;
    },

    mounted(){
        this.getOficinas();
        this.getCargos();
        this.getPerfiles();
        this.getEjecutoras();
        if(this.parametro !== 'nuevo'){
            this.title = 'Actualizar Personal';
            this.enabledDocumento = true,
            this.personalId = this.parametro;
            this.getPersona(this.parametro);
        } else {
           this.enabledDocumento = false;
        }
    },

    computed: {
        validateForm(){
            return !this.errors.any() 
            && this.inputDocumento  !== null 
            && this.inputNombres    !== null 
            && this.inputApellidos  !== null 
            && this.inputEmail      !== null
            && (this.selectedIpress !== null || this.checkRoot) 
            && this.selectedCargo   !== null 
            && this.selectedPerfil  !== null 
            && this.selectedEstado  !== null;
        }
    },

    watch: {
        checkRoot(value){
            this.visibleIpress = !value;
        }
    },

    methods: {
        getOficinas(){
            this.$vs.loading({
                container: '#div-detalle-persona-with-loading',
                scale: 0.7
            });
            this.$http.selectionOficinas()
            .then(response => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                if(response.status === 200){
                    this.itemsOficina = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getCargos(){
            this.$vs.loading({
                container: '#div-detalle-persona-with-loading',
                scale: 0.7
            });
            this.$http.selectionCargos()
            .then(response => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                if(response.status === 200){
                    this.itemsCargo = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getPerfiles(){
            this.$vs.loading({
                container: '#div-detalle-persona-with-loading',
                scale: 0.7
            });
            this.$http.selectionProfiels()
            .then(response => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                if(response.status === 200){
                    this.itemsPeril = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getEjecutoras(){
            this.$vs.loading({
                container: '#div-detalle-persona-with-loading',
                scale: 0.7
            });
            this.$http.seleccionarUnidadEjecutora()
            .then(response => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                if(response.status === 200){
                    this.itemsEjecutora = response.data;
                    console.log(this.itemsEjecutora);
                }
            })
            .catch(error => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        autoCompleteFunc(){},

        buscarPersonal(){
            if(this.inputDocumento === null){
                this.showMessageAlert('Ingrese el número de documento a buscar');
                return;
            }

            this.$vs.loading({
                container: '#div-detalle-persona-with-loading',
                scale: 0.7
            });
            this.$http.consultPersona(this.inputDocumento)
            .then(response => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                if(response.status === 200){
                    this.loadDataBusqueda(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getPersona(value){
            if(value === null || value === ''){
                this.showMessageAlert('El valor a buscar no existe.');
                return;
            }
            this.$vs.loading();
            this.$http.findPersonaById(value)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.loadData(response.data);
                }
            })
            .catch(error => {
                console.log(error);
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        loadDataBusqueda(data){
            this.inputDocumento     = data.numDocumento;
            this.inputNombres       = data.nombres;
            this.inputApellidos     = data.apellidos;
            this.inputEmail         = data.email;
            this.inputTelefono      = data.telefono;
            this.inputDireccion     = data.direccion;
            this.inputCategoria     = data.categoria;
            this.inputProfesion     = data.profesion;
            this.selectedOficina    = { value: data.oficina.id, label: data.oficina.descripcion };
            this.selectedEstado     = { value: 1, label: 'ACTIVO' };
        },

        loadData(data){
            const device = this.itemsDevice.find((element) => element.value === data.origen);

            this.enabledDocumento   = true,
            this.inputDocumento     = data.numDocumento;
            this.inputNombres       = data.nombres;
            this.inputApellidos     = data.apellidos;
            this.inputEmail         = data.email;
            this.inputTelefono      = data.telefono;
            this.inputDireccion     = data.direccion;
            this.inputCategoria     = data.categoria;
            this.inputProfesion     = data.profesion;
            this.selectedOficina    = { value: data.oficina.id, label: data.oficina.descripcion };
            this.selectedEjecutora  = { value: data.ejecutora.id, label: data.ejecutora.id + ' - ' + data.ejecutora.nombre };
            this.selectedCargo      = { value: data.cargo.id, label: data.cargo.descripcion };
            this.selectedPerfil     = { value: data.perfil.id, label: data.perfil.descripcion };
            this.selectedDevice     = device === undefined || device === null ? { value: 3, label: 'Otros dispositivos' } : device;
            this.selectedEstado     = data.enable ? { value: 1, label: 'ACTIVO' } : { value: 2, label: 'BLOQUEADO' };
        },

        guardar(){
            const data = {
                numDocumento: this.inputDocumento,
                nombres     : this.inputNombres.trim().toUpperCase(),
                apellidos   : this.inputApellidos.trim().toUpperCase(),
                oficina     : { id: this.selectedOficina.value, descripcion: this.selectedOficina.label },
                ejecutora   : this.selectedEjecutora.value,
                email       : this.inputEmail.trim(),
                telefono    : this.inputTelefono.trim(),
                cargo       : { id: this.selectedCargo.value, descripcion: this.selectedCargo.label },
                categoria   : this.inputCategoria === null ? null : this.inputCategoria.trim().toUpperCase(),
                profesion   : this.inputProfesion === null ? null : this.inputProfesion.trim().toUpperCase(),
                perfil      : { id: this.selectedPerfil.value, descripcion: this.selectedPerfil.label },
                device      : this.selectedDevice === null || this.selectedDevice === undefined ? 4 : this.selectedDevice.value,
                estado      : this.selectedEstado.value === 1 ? true : false,
            }

            if(!this.enabledDocumento){
                this.$vs.loading({
                    container: '#div-detalle-persona-with-loading',
                    scale: 0.7
                });
                this.$http.createPersona(data)
                .then(response => {
                    this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                    if(response.status === 201){
                        this.regresar('Se ha creado de forma correcta.');
                    }
                })
                .catch(error => {
                    this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                    this.showMessageError(error.response.status, error.response.data.message);
                });
            } else {
                const dataUpdate = {
                    nombres     : this.inputNombres.trim().toUpperCase(),
                    apellidos   : this.inputApellidos.trim().toUpperCase(),
                    oficina     : { id: this.selectedOficina.value, descripcion: this.selectedOficina.label },
                    email       : this.inputEmail.trim(),
                    telefono    : this.inputTelefono.trim(),
                    cargo       : { id: this.selectedCargo.value, descripcion: this.selectedCargo.label },
                    categoria   : this.inputCategoria === null ? null : this.inputCategoria.trim().toUpperCase(),
                    profesion   : this.inputProfesion === null ? null : this.inputProfesion.trim().toUpperCase(),
                    perfil      : { id: this.selectedPerfil.value, descripcion: this.selectedPerfil.label },
                    device      : this.selectedDevice === null || this.selectedDevice === undefined ? 4 : this.selectedDevice.value,
                    estado      : this.selectedEstado.value === 1 ? true : false,
                }
                this.$vs.loading({
                    container: '#div-detalle-persona-with-loading',
                    scale: 0.7
                });
                this.$http.updatePersona(this.personalId, dataUpdate)
                .then(response => {
                    this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                    if(response.status === 200){
                        this.regresar('Se actualizó de forma correcta');
                    }
                })
                .catch(error => {
                    this.$vs.loading.close('#div-detalle-persona-with-loading > .con-vs-loading');
                    this.showMessageError(error.response.status, error.response.data.message);
                });
            }

        },

        regresar(value){
            this.$vs.notify({
                title: 'Información',
                text: value,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });

            this.$router.push({
				name: 'usuario-acceso-personal'
			}).catch(() => {});
        },

        clearForm(){
            this.enabledDocumento       = this.parametro === 'nuevo' ? false : true,
            this.visibleIpress          = true;
            this.inputDocumento         = this.parametro === 'nuevo' ? null : this.inputDocumento,
            this.inputNombres           = null;
            this.inputApellidos         = null;
            this.inputEmail             = null;
            this.inputTelefono          = null;
            this.inputDireccion         = null;
            this.inputArea              = null;
            this.inputAreaAbreviatura   = null;
            this.inputCategoria         = null;
            this.inputProfesion         = null;
            this.selectedCargo          = null;
            this.selectedPerfil         = null;
            this.selectedEstado         = null;
        },


        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.dialog({
                    color: 'danger',
                    title: `Aviso`,
                    text: message,
                    //accept:this.acceptAlert
                    acceptText: 'Aceptar'
                });
            }
            if(status === 401){
                this.popupEliminarPersonal = false;
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }
}
</script>
<style lang="css">

</style>
